export default __webpack_public_path__ + "static/media/freja-happy.41fcd602.svg";